import { render, staticRenderFns } from "./changeLogAdmin.vue?vue&type=template&id=668a8386&"
import script from "./changeLogAdmin.vue?vue&type=script&lang=js&"
export * from "./changeLogAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports